import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { styled, alpha } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import SortIcon from "@mui/icons-material/Sort";
import Checkbox from "@mui/material/Checkbox";
import { Chip, Stack, Typography } from "@mui/material";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import FavoriteIcon from "@mui/icons-material/Star";
import Avatar from "@mui/material/Avatar";

const iconsSeeOrder= {
  onlyFaviorate:<FavoriteIcon sx={{color:"#FFC107!important"}} />,
  onlyAssigned:<Avatar
  alt={""}
  src={"/static/icons/icon-entidadebeneficiaria.svg"}
  variant="square"
  sx={{
    width: 18,
    height: 18,
    mr:"12px",
    // ml:"-2px"
  }}
/>
}
const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 200,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

const BootstrapButton = styled(Button)({
  boxShadow: "none",
  textTransform: "none",
  fontSize: 16,
  padding: "10px 22px",
  border: "2px solid",
  lineHeight: 1.5,
  backgroundColor: "#fff",
  color: "#637381",
  borderColor: "rgba(145, 158, 171, 0.24)",
  fontFamily: "Poppins",
  fontWeight: 500,
  maxHeight:'52px',
  "&:hover": {
    backgroundColor: "#fff",
    borderColor: "#37B34A",
    boxShadow: "none",
  },
  "&:active": {
    boxShadow: "none",
    backgroundColor: "#fff",
    borderColor: "#37B34AB5",
  },
  "&:focus": {
    boxShadow: "0 0 0 0.2rem #37B34AB5",
  },
});

const SearchByCodDoacao = (props) => {
  const {
    buttonName,
    t,
    setIdValue,
    idValue
  } = props;

  const changeIdValue =(e)=>{
    const inputValue = e.target.value;

    // Permite apenas números
    if (/^\d*$/.test(inputValue)) {
      setIdValue(inputValue);
    }
  }

  return (
    <div>
     <input type="text" placeholder={"Pesquisar por código de doação"} 
            onChange={(e)=>changeIdValue(e)}
            value={idValue ?? ""}
            style={{
              display:'inline-flex',
              alignItems:'center',
              justifyContent:'center',
              position:'relative',
              boxSizing:'border-box',
              outline:0,
              margin:0,
              userSelect:'none',
              verticalAlign:'middle',
              textDecoration:'none',
              borderRadius:'8px',
              transition: 'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
              boxShadow: 'none',
              textTransform: 'none',
              fontSize: '16px',
              padding: '18px 22px',
              border: '2px solid',
              lineHeight: '1.5',
              backgroundColor: '#fff',
              color: '#637381',
              borderColor: 'rgba(145, 158, 171, 0.24)',
              fontFamily: 'Poppins',
              fontWeight: '500',
              maxHeight:'52px',
              maxWidth: "145px"
            }}/>
    </div>
  );
};

SearchByCodDoacao.propTypes = {
  t: PropTypes.func,
  setIdValue: PropTypes.func,
  idValue: PropTypes.number,
};

export default SearchByCodDoacao;
